<template>
  <form @submit.prevent="onSubmit" ref="form" class="_attachmentsForm">
    
    <AttachmentsDropzone
      class="_attachmentsForm__dropzone"
      v-model="files"
      v-if="!model || !model.id"
      @addedFiles="onAddedFiles"
    />
    
    <div class="_attachmentsForm__files">
      <AttachmentsFormItem
        v-for="(_item, _index) in filteredAttachments"
        v-model="filteredAttachments[_index]"
        :key="_index"
        :docTypes="docTypes"
        :index="_index"
      />
    </div>
    
    <div class="md-layout md-alignment-center-right _attachmentsForm__action">
      <md-button class="md-raised md-primary" type="submit" :disabled="!isFormValid">
        <span>Upload</span>
      </md-button>
    </div>

  </form>
</template>

<script>
  import AttachmentsDropzone from '@/components/DynamicForm/Attachments/AttachmentsDropzone';
  import AttachmentsFormItem from '@/components/DynamicForm/Attachments/AttachmentsFormItem';

  export default {
    name: 'CommentAttachmentsForm',
    mixins: [],
    components: {
      AttachmentsDropzone,
      AttachmentsFormItem,
    },
    props: {
      model: {
        type: Array,
        required: false,
      },
      docTypes: {
        type: Array,
        required: true,
      }
    },
    data: () => ({
      files: null,
      attachments: [],
    }),
    computed: {
      filteredAttachments() {
        return this.attachments.filter(_attachment => {
          if (_attachment.isDeleted) {
            return false
          }
          return !_attachment.internal || this.$Session.isInternalGroupMember
        })
      },
      isFormValid() {
        return this.filteredAttachments.every(_attachment => {
          return (
            (_attachment.file || _attachment.id)
            && _attachment.type
          )
        })
      }
    },
    methods: {
      /**
       * Reset form
       * @return {void}
       */
      onFormReset() {
        this.attachments = []
      },
      /**
       * When new files are added update files list
       * @param  {FileList} fileList 
       * @return {void}          
       */
      onAddedFiles(fileList) {
        if (fileList && fileList.length) {
          for (const _file of fileList) {
            this.attachments.push({
              file: _file,
              name: _file.name,
              description: '',
            })
          }
        }
      },
      /**
       * Form submitted - add or update attachment
       * @returns {void}
       */
      async onSubmit() {
        this.$emit('success', this.attachments);
      },
    },
    watch: {
      /**
       * Watch for changes to model - the attachment relation object passed to 
       * form - contains the attachment as a prop
       * Update internal state to reflect attachment
       */
      model: {
        immediate: true,
        handler: function() {
          this.attachments = []
          if (this.model && this.model.length) {
            this.attachments = this.model.map(_attachment => {
              const clone = Object.assign({}, _attachment)
              if (clone.type) {
                clone.type = clone.type.replace(/\s/ig, '_')
              }
              clone.isEdit = true
              return clone
            })
          }
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  /**/
</style>
